import { IonButton, IonIcon, IonRouterLink } from '@ionic/react';
import React from 'react';

import { ButtonContainer, Spacer } from '@/components/common';
import { RequestSummary } from '@/components/summary';
import { useLanguage } from '@/contexts/LanguageContext';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import { useToast } from '@/hooks';
import { checkmarkCircleOutline, checkmarkDone } from 'ionicons/icons';

import './ThankYou.css';

const ThankYou: React.FC = () => {
  const { t } = useLanguage();
  const {
    clinic,
    selectedDentist: dentist,
    patient,
    request,
    durationInMinutes,
    reset: onReset
  } = useScheduleFlow();
  const displayToast = useToast();

  const copy = {
    subHeader: t('schedule.thankYou.subHeader'),
    header: t('schedule.thankYou.header'),
    message: t('schedule.thankYou.message'),
    buttonText: t('schedule.thankYou.buttonText'),
    startOverPrompt: t('schedule.thankYou.startOverPrompt'),
    startOverText: t('schedule.thankYou.startOverText'),
    toastMessage: t('schedule.thankYou.toastMessage')
  };

  const onDone = () => {
    displayToast({
      message: copy.toastMessage,
      duration: 5000,
      position: 'bottom',
      positionAnchor: 'doneButton'
    });
  };

  if (!clinic) return null;

  return (
    <div className="thank-you">
      <IonIcon
        color="primary"
        icon={checkmarkDone}
        className="thank-you__icon"
      />
      <h4 className="thank-you__sub-header">{copy.subHeader}</h4>
      <h1 className="thank-you__header">{copy.header}</h1>
      <p className="thank-you__message">{copy.message}</p>
      <Spacer top={24} />
      <RequestSummary
        clinic={clinic}
        dentist={dentist}
        patient={patient}
        request={request}
        durationInMinutes={durationInMinutes}
      />
      <Spacer top={16} bottom={102}>
        <div className="thank-you__start-over">
          <p>{copy.startOverPrompt}</p>
          <IonRouterLink onClick={onReset}>{copy.startOverText}</IonRouterLink>
        </div>
      </Spacer>
      <ButtonContainer>
        <IonButton
          className="thank-you__done-button"
          onClick={onDone}
          expand="block"
          fill="solid"
          size="default"
        >
          <IonIcon slot="start" icon={checkmarkCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default ThankYou;
